export default __webpack_public_path__ + "static/cross-mark-icon-8-9578a9614c02b17a36aab3eec66e2ad0.jpg";